module.exports = __webpack_public_path__ + "img/finance_cooperate1.eeb0dc80.png";